function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
/**
 * Stateless search executor: builds Algolia request params from PLP state,
 * applies price scaling, calls the API, and normalises the response.
 */

/**
 * @typedef {Object} SearchConfig
 * @property {string}   indexName
 * @property {number}   hitsPerPage
 * @property {string}   priceAttribute
 * @property {number}   priceScale
 * @property {string[]} collectionFacetFilters
 * @property {Array<{ attribute: string, type: string }>} facets
 */

/**
 * Build the `search()` request payload from current PLP state.
 *
 * @param {import('./algolia-state').AlgoliaState['snapshot']} state
 * @param {SearchConfig} config
 * @returns {object} Algolia multi-search request body
 */
export function buildSearchParams(state, config) {
  var facetFilters = [];
  if (config.collectionFacetFilters.length) {
    facetFilters.push(...config.collectionFacetFilters);
  }
  var _loop = function _loop() {
      _ref2 = _slicedToArray(_ref3, 2);
      var attr = _ref2[0];
      var values = _ref2[1];
      if (!values.length) return 1; // continue
      // OR within a facet, AND between facets
      facetFilters.push(values.map(v => "".concat(attr, ":").concat(v)));
    },
    _ref2;
  for (var _ref3 of Object.entries(state.refinements)) {
    if (_loop()) continue;
  }
  var numericFilters = [];
  for (var _ref6 of Object.entries(state.numericRange)) {
    var _ref5 = _slicedToArray(_ref6, 2);
    var attr = _ref5[0];
    var range = _ref5[1];
    var scale = attr === config.priceAttribute ? config.priceScale : 1;
    if (range.min != null && Number.isFinite(range.min)) {
      numericFilters.push("".concat(attr, ">=").concat(Math.round(range.min * scale)));
    }
    if (range.max != null && Number.isFinite(range.max)) {
      numericFilters.push("".concat(attr, "<=").concat(Math.round(range.max * scale)));
    }
  }
  var facetAttrs = config.facets.map(f => f.type === 'rangeInput' ? config.priceAttribute : f.attribute);
  var indexName = state.sortIndex || config.indexName;
  var primaryRequest = _objectSpread(_objectSpread(_objectSpread({
    indexName,
    query: state.query || '',
    hitsPerPage: config.hitsPerPage,
    page: Math.max(0, (state.page || 1) - 1),
    facets: facetAttrs,
    filters: 'NOT meta.content.hidden_from_online_store:true'
  }, facetFilters.length ? {
    facetFilters
  } : {}), numericFilters.length ? {
    numericFilters
  } : {}), {}, {
    maxValuesPerFacet: 100,
    distinct: 1
  });
  var requests = [primaryRequest];
  if (config.separateCardAttr) {
    var secondaryFacetFilters = [...config.collectionFacetFilters];
    requests.push(_objectSpread(_objectSpread({
      indexName,
      query: '',
      hitsPerPage: 200,
      page: 0
    }, secondaryFacetFilters.length ? {
      facetFilters: secondaryFacetFilters
    } : {}), {}, {
      distinct: 0
    }));
  }
  return {
    requests
  };
}

/**
 * Execute a search and return a normalised result object.
 *
 * @param {import('algoliasearch/lite').LiteClient} client
 * @param {ReturnType<typeof buildSearchParams>} params
 * @returns {Promise<{ hits: object[], facets: Record<string, Record<string, number>>, nbHits: number, nbPages: number, page: number }>}
 */
export function executeSearch(_x, _x2) {
  return _executeSearch.apply(this, arguments);
}
function _executeSearch() {
  _executeSearch = _asyncToGenerator(function* (client, params) {
    var _res$results$, _primary$nbHits, _primary$nbPages, _primary$page;
    var res = yield client.search(params);
    var primary = res.results[0];
    var secondary = (_res$results$ = res.results[1]) !== null && _res$results$ !== void 0 ? _res$results$ : null;
    return {
      hits: primary.hits || [],
      facets: primary.facets || {},
      nbHits: (_primary$nbHits = primary.nbHits) !== null && _primary$nbHits !== void 0 ? _primary$nbHits : 0,
      nbPages: (_primary$nbPages = primary.nbPages) !== null && _primary$nbPages !== void 0 ? _primary$nbPages : 0,
      page: ((_primary$page = primary.page) !== null && _primary$page !== void 0 ? _primary$page : 0) + 1,
      separateCardHits: secondary ? secondary.hits || [] : []
    };
  });
  return _executeSearch.apply(this, arguments);
}